import { Message } from 'element-ui';
import Cookies from 'js-cookie'
import { getMultiLanguageConfig, getMultiLanguageConfigCache } from '@/api/system'

const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  noticeNumber: '0',
  lang: 'chinese', // 语言
  langMessages: null, // 语言包
  timeZone: '' // 时区
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = true
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_Num: (state, size) => {
    state.noticeNumber = size
  },
  // 设置语言
  SET_LANG: (state, lang) => {
    state.lang = lang
  },
  // 设置多语言
  SET_LANG_MESSAGES: (state, messages) => {
    state.langMessages = messages
  },
  // 设置时区
  SET_TIME_ZONE: (state, timeZone) => {
    state.timeZone = timeZone
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setNum({ commit }, size) {
    commit('SET_Num', size)
  },
  async getLangMessagesAction({ commit, state }) {
    // const { code, data, message } = await getMultiLanguageConfig({
    //   functionModuleList: ["PORTAL"],
    //   typeList: ["FRONTEND_PROMPT"],
    //   page: 1,
    //   pageSize: 999999
    // })
    const { status, data, message } = await getMultiLanguageConfigCache({functionModule: "PORTAL"})
    if (status === 200) {
      let messages = {
        chinese: {},
        english: {},
        vietnamese: {}
      }
      data.forEach(item => {
        messages.chinese[item.code] = item.chinese
        messages.english[item.code] = item.english
        messages.vietnamese[item.code] = item.vietnamese
      })
      console.log(messages, 'messages========');
      // 语言包有更新时，重新加载页面
      if (JSON.stringify(state.langMessages) !== JSON.stringify(messages)) {
        commit('SET_LANG_MESSAGES', messages)
        location.reload()
      }
    } else {
      Message(message)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
